import { Navigate, Outlet } from '@tanstack/react-router'
import { Settings } from 'lucide-react'
import { type ReactNode } from 'react'

import { EmptyState, Page, PageHeader } from '@aeris/ui'

import { ConfigTabs } from '../components/config-tabs.tsx'
import { useAuth } from '../lib/auth-context.ts'
import { defaultTabOf } from '../lib/config-tabs.ts'
import { useWorkspace } from '../lib/workspace.ts'

/**
 * Configurações da loja: as seis telas de administração numa página (F068).
 *
 * Mesmo mecanismo e mesmas razões de `atendimento-config.tsx`, que carrega o
 * comentário longo — rota de layout **sem `path`**, as seis telas nos endereços
 * que sempre tiveram, `PAGES` e as seis permissões intactas.
 *
 * As seis são o que se ajusta uma vez por loja: o que ela aceita como
 * pagamento, os caixas físicos do balcão, os marketplaces, o cadastro da
 * empresa, quem tem acesso, e as máquinas que continuam vendendo sem internet.
 *
 * Terminais é a única que um operador de balcão enxerga (`pos.operate`), e é
 * por isso que esta página não exige permissão própria: quem chega aqui vê
 * exatamente as abas que já via como linhas do menu, nem uma a mais.
 */
export const ConfiguracoesLayout = (): ReactNode => (
  <Page>
    {/*
      Sem descrição (F132): a aba aberta já diz o que é, no próprio cabeçalho.
      Eram dois parágrafos empilhados antes de qualquer campo.
    */}
    <PageHeader title="Configurações da loja" />
    <ConfigTabs hub="configuracoes" />
    <Outlet />
  </Page>
)

/** A linha do menu. Manda para Formas de pagamento, ou para o que a pessoa puder abrir. */
export const ConfiguracoesHub = (): ReactNode => {
  const { allows, showsPage } = useAuth()
  const workspace = useWorkspace()

  const primeira = defaultTabOf(
    'configuracoes',
    (entry) =>
      (entry.permission === undefined || allows(entry.permission)) &&
      showsPage(entry.module)
  )

  if (primeira === undefined) {
    return (
      <Page>
        <PageHeader title="Configurações da loja" />
        <EmptyState
          icon={<Settings aria-hidden="true" className="h-8 w-8" />}
          title="Nada para configurar aqui"
          description="Seu acesso não inclui nenhuma das telas de configuração da loja. Fale com quem administra a conta."
        />
      </Page>
    )
  }

  return <Navigate replace to={workspace.routeFor(primeira.module)} />
}
